module.exports = __webpack_public_path__ + "static/media/upload.547c029f.svg";